<template>
    <div class="search-vehicle-component p-2">
        <transition
            name="fade"
        >
            <div
                class="row"
                style="animation-duration: 0.3s"
            >
                <div
                    :class="!show_listing ? 'col-sm-4' : ''"
                    class="col-xs-12"
                >
                    <div class="box">
                        <div class="search-field-container">
                            <label>Condition</label>
                            <b-form-radio-group v-model="filters.condition_id">
                                <b-form-radio :value="filters.condition_id">
                                    Pre-owned
                                </b-form-radio>
                            </b-form-radio-group>
                        </div>
                    </div>
                </div>
                <div
                    v-show="show_listing"
                    :class="!show_listing ? 'col-sm-4' : ''"
                    class="col-xs-12"
                >
                    <div class="box">
                        <div class="search-field-container">
                            <label>Sort (Price & Mileage)</label>
                            <select
                                v-model="filters.sort"
                                class="mr-2 mt-1 mt-md-0 form-control"
                                title="sort"
                            >
                                <option :value="null">Sort</option>
                                <option
                                    v-for="sort in sorts"
                                    :value="sort.value"
                                >
                                    {{ sort.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div
                    :class="!show_listing ? 'col-sm-4' : ''"
                    class="col-xs-12"
                >
                    <div class="box">
                        <div class="search-field-container">
                            <label>Make</label>
                            <select
                                @change="onSelectMake"
                                class="form-control"
                                title="make"
                                v-model="filters.vehicle_make_id"
                            >
                                <option :value="null">Filter by make</option>
                                <option :key="make.id"
                                        :value="make.id"
                                        v-for="make in makes">{{ make.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div
                    :class="!show_listing ? 'col-sm-4' : ''"
                    class="col-xs-12"
                >
                    <div class="box">
                        <div class="search-field-container">
                            <label>Model</label>
                            <select
                                @change="onSelectModel"
                                class="form-control"
                                title="model"
                                v-model="filters.vehicle_model_id"
                            >
                                <option :value="null">Filter by model</option>
                                <option :key="model.id"
                                        :value="model.id"
                                        v-for="model in models">{{ model.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div
                    :class="!show_listing ? 'col-sm-4' : ''"
                    class="col-xs-12"
                >
                    <div class="box">
                        <div class="search-field-container">
                            <label>Trim</label>
                            <select
                                class="form-control"
                                title="trim"
                                v-model="filters.vehicle_trim_id"
                            >
                                <option :value="null">Filter by trim</option>
                                <option :key="trim.id"
                                        :value="trim.id"
                                        v-for="trim in trims">{{ trim.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div
                    :class="!show_listing ? 'col-sm-4' : ''"
                    class="col-xs-12"
                >
                    <div class="box px-2 pb-3">
                        <div class="search-field-container">
                            <label for="filter-year-range">Year</label>
                            <range-slider
                                id="filter-year-range"
                                v-model="filters.min_max_year"
                                :max="maxYear"
                                :min="minYear"
                                title="year range"
                                @change="filters.min_max_year = $event"
                            />
                        </div>
                    </div>
                </div>
                <div
                    :class="!show_listing ? 'col-sm-4' : ''"
                    class="col-xs-12"
                >
                    <div class="box px-2 pb-3">
                        <div class="search-field-container">
                            <label for="filter-price-range">Price</label>
                            <range-slider
                                id="filter-price-range"
                                v-model="filters.min_max_price"
                                :locale-string="true"
                                :max="200000"
                                :min="1"
                                title="price range"
                                @change="filters.min_max_price = $event"
                            />
                        </div>
                    </div>
                </div>
                <div
                    v-show="show_listing"
                    :class="!show_listing ? 'col-sm-4' : ''"
                    class="col-xs-12"
                >
                    <div class="box px-2 pb-3">
                        <div class="search-field-container">
                            <label>Mileage</label>
                            <range-slider
                                v-model="filters.mileage_range"
                                :locale-string="true"
                                :max="500000"
                                :min="1"
                                title="mileage range"
                                @change="filters.mileage_range = $event"
                            />
                        </div>
                    </div>
                </div>
                <div
                    v-show="show_listing"
                    :class="!show_listing ? 'col-sm-4' : ''"
                    class="col-xs-12"
                >
                    <div class="box">
                        <div class="search-field-container">
                            <label>Body</label>
                            <select class="form-control" title="body" v-model="filters.body_id">
                                <option :value="null">Filter by body</option>
                                <option v-if="isMainBodyType(body)"
                                        :key="body.id"
                                        :value="body.id"
                                        v-for="body in bodies">{{ body.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div
                    v-show="show_listing"
                    :class="!show_listing ? 'col-sm-4' : ''"
                    class="col-xs-12"
                >
                    <div class="box">
                        <div class="search-field-container">
                            <label>Colour</label>
                            <select class="form-control" title="colour" v-model="filters.color_id">
                                <option :value="null">Filter by color</option>
                                <option :key="color.id"
                                        :value="color.id"
                                        v-for="color in colors">{{ color.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div
                    v-show="show_listing"
                    :class="!show_listing ? 'col-sm-4' : ''"
                    class="col-xs-12"
                >
                    <div class="box py-2">
                        <div class="search-field-container">
                            <label>Transmission</label>
                            <select class="form-control" title="transmission" v-model="filters.transmission_id">
                                <option :value="null">Filter by transmission</option>
                                <option :key="transmission.id"
                                        :value="transmission.id"
                                        v-for="transmission in transmissions">{{ transmission.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div
                    v-show="show_listing"
                    :class="!show_listing ? 'col-sm-4' : ''"
                    class="col-xs-12"
                >
                    <div class="box py-2">
                        <div class="search-field-container">
                            <label>Distance From Me</label>
                            <select class="form-control" title="distance from me" v-model="filters.distance_from_me_id">
                                <option :value="null">Filter by distances</option>
                                <option :key="distance.id"
                                        :value="distance.id"
                                        v-for="distance in distances_from_me">{{ distance.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4"></div>
                <div
                    v-show="show_listing"
                    :class="!show_listing ? 'col-sm-4' : ''"
                    class="col-xs-12"
                >
                    <div class="box">
                        <div class="search-field-container">
                            <label>Keywords</label>
                            <input class="form-control"
                                   placeholder="Keywords"
                                   title="Keywords"
                                   type="search" v-model="filters.keyword">
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4"></div>
            </div>
        </transition>
        <div :class="{ 'mt-3' : !is_mobile, 'mb-3' : show_listing || !is_mobile }"
             class="d-flex justify-content-center mt-3"
        >
            <button @click.prevent="showListing()"
                    class="btn btn-primary waves-effect waves-light mr-2" type="button">
                <i class="mdi mdi-eye"/>
                Show Listings
            </button>
            <button @click.prevent="clearFilters(true)"
                    class="btn btn-secondary waves-effect waves-light" type="button">
                <i class="mdi mdi-filter"/>
                Clear Filters
            </button>
        </div>
    </div>
</template>

<script>
import RangeSlider from "@/components/custom/RangeSlider";

import Routes from "@/constants/routes";
import Getters from "@/constants/store/getters";
import Vehicle from "@/models/vehicle";
import {cloneDeep, find, forEach, get, includes, keys, omit, map} from 'lodash';
import VehicleMixin from '@/mixins/vehicle';
import YearMixin from "@/mixins/year";

const {
    config: { hide_new_vehicles_enabled },
} = window.App.state

export default {
    components: {
        RangeSlider,
    },
    mixins: [VehicleMixin, YearMixin],
    props: {
        shouldClearFilters: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            hide_new_vehicles_enabled,
            filters: this.getDefaultFilters(),
            show_listing: false,
            selected_make: null,
            selected_model: null,
            selected_trim: null,
            is_basic: {
                color: '#ccc',
            },
            is_advanced: {
                color: '#59bdd3',
            },
            advanced_search: false,
            sorts: [
                {
                    name: 'Price (ASC)',
                    value: 'price',
                },
                {
                    name: 'Price (DESC)',
                    value: '-price',
                },
                {
                    name: 'Mileage (ASC)',
                    value: 'mileage',
                },
                {
                    name: 'Mileage (DESC)',
                    value: '-mileage',
                }
            ]
        }
    },
    computed: {
        makes() {
            return this.$store.state.vehicle_makes.data;
        },
        models() {
            if (!this.selected_make) {
                return [];
            }
            return this.selected_make.vehicle_models;
        },
        trims() {
            if (!this.selected_model) {
                return [];
            }
            return this.selected_model.vehicle_trims;
        },
        bodies() {
            const bodies = this.$store.getters[Getters.get_bodies];
            return _.orderBy(bodies, (item) => {
                return item?.meta?.order;
            });
        },
        colors() {
            return this.$store.getters[Getters.get_colors]
        },
        conditions() {
            return this.$store.getters[Getters.get_conditions].map(condition => {
                if (this.hide_new_vehicles_enabled && (condition.name === 'New' || condition.name === 'Damaged')) {
                    return null
                }
                return {
                    ...condition,
                    name: condition.name.replace('Certified', '')
                }
            }).filter(condition => condition !== null)
        },
        transmissions() {
            return this.$store.getters[Getters.get_transmissions]
        },
        distances_from_me() {
            return this.$store.getters[Getters.get_distances_from_me]
        },
    },
    mounted() {
        this.initRangeSelects();
        this.selected_make = find(this.makes, {id: Number(this.$route.query.vehicle_make_id)});
        this.selected_model = find(this.models, {id: Number(this.$route.query.vehicle_model_id)});
        if (this.shouldShowListing()) {
            this.showListing();
        }
    },
    methods: {
        getDefaultFilters(options = {}) {
            const {
                shouldNotClearBodyIdValue = false,
                shouldNotClearDealershipListingValue = false,
            } = options;

            return {
                vehicle_make_id: null,
                vehicle_model_id: null,
                min_max_year: [],
                min_max_price: [],
                mileage_range: [],
                vehicle_price_min: null,
                vehicle_price_max: null,
                body_id: shouldNotClearBodyIdValue ? this.filters.body_id : null,
                vehicle_trim_id: null,
                color_id: null,
                condition_id: 25,
                transmission_id: null,
                distance_from_me_id: null,
                keyword: null,
                dealership_listing_only: shouldNotClearDealershipListingValue ? this.filters.dealership_listing_only : null,
                status: 0,
                sort: null,
            };
        },
        initRangeSelects() {
            if (!this.filters.min_max_year.length) {
                this.filters.min_max_year = [this.minYear, this.maxYear];
            }
            if (!this.filters.min_max_price.length) {
                this.filters.min_max_price = [1, 200000];
            }
            if (!this.filters.mileage_range.length) {
                this.filters.mileage_range = [1, 500000];
            }
        },
        searchVehicle(page) {
            let vehicle = Vehicle
                .include(
                    'vehicleYear',
                    'vehicleMake',
                    'vehicleModel',
                    'vehicleTrim',
                    'transmission',
                    'body',
                    'condition',
                    'color',
                    'fuelType',
                    'numberOfDoors',
                    'drive',
                    'media',
                    'images',
                    'company',
                    'deals.buyer.companies',
                    'deals.seller.companies',
                );
            if (this.filters.vehicle_make_id) {
                vehicle = vehicle.where('vehicle_make_id', this.filters.vehicle_make_id);
            }
            if (this.filters.vehicle_model_id) {
                vehicle = vehicle.where('vehicle_model_id', this.filters.vehicle_model_id)
            }

            vehicle = vehicle.whereIn('min_max_year', this.filters.min_max_year);
            vehicle = vehicle.whereIn('min_max_price', this.filters.min_max_price);

            if (this.filters.mileage_range) {
                vehicle = vehicle.whereIn('mileage_range', this.filters.mileage_range)
            }
            if (this.filters.body_id) {
                vehicle = vehicle.where('body_id', this.filters.body_id)
            }
            if (this.filters.vehicle_trim_id) {
                vehicle = vehicle.where('vehicle_trim_id', this.filters.vehicle_trim_id)
            }
            if (this.filters.color_id) {
                vehicle = vehicle.where('color_id', this.filters.color_id)
            }
            if (this.filters.condition_id) {
                vehicle = vehicle.whereIn('condition_id', map(this.conditions, 'id'))
            }
            if (this.filters.transmission_id) {
                vehicle = vehicle.where('transmission_id', this.filters.transmission_id)
            }
            if (this.filters.distance_from_me_id) {
                vehicle = vehicle.where('distance_from_me_id', this.filters.distance_from_me_id)
            }
            if (this.filters.keyword) {
                vehicle = vehicle.where('keyword', this.filters.keyword)
            }

            vehicle = vehicle.where(
                'dealership_listing_only',
                this.filters.dealership_listing_only ? 1 : 0
            );

            if (this.filters.status) {
                vehicle = vehicle.where('status', this.filters.status)
            }

            if (this.filters.sort) {
                vehicle = vehicle.orderBy(this.filters.sort)
            }

            if (page) {
                vehicle = vehicle.page(page);
            }
            return vehicle.get();
        },
        setFilter(key, value) {
            this.filters[key] = value;
        },
        getFilter(key) {
            return this.filters[key];
        },
        showListing(page) {
            let filters = cloneDeep(this.$route.query);
            forEach(filters, (val, key) => {
                if (includes(keys(this.filters), key)) {
                    filters = omit(filters, key);
                }
            });
            forEach(this.filters, (val, key) => {
                if (val !== null) {
                    if (key === 'dealership_listing_only') {
                        filters[key] = val ? 1 : 0;
                        return;
                    }
                    filters[key] = val;
                }
            });

            if (keys(filters).length > 0) {
                this.$router.replace({
                    name: Routes.vehicle,
                    query: filters
                })
            }
            this.show_listing = true;
            this.$emit('showListing', page);
        },
        onSelectMake(e) {
            this.selected_make = find(this.makes, {id: Number(e.target.value)});
            this.filters.vehicle_model_id = null;
            this.selected_model = null;
            this.filters.vehicle_trim_id = null;
            this.selected_trim = null;
        },
        onSelectModel(e) {
            this.selected_model = find(this.models, {id: Number(e.target.value)});
            this.filters.vehicle_trim_id = null;
            this.selected_trim = null;
        },
        shouldShowListing() {
            let show_listing = false;
            forEach(this.filters, (filter, key) => {
                let query = get(this.$route.query, key, null);
                if (query !== null) {
                    show_listing = true;
                    if (key === 'dealership_listing_only') {
                        this.filters[key] = query == 1;
                        return;
                    }
                    this.filters[key] = query;
                }
            });
            return show_listing;
        },
        clearFilters(isTriggered = false) {
            this.filters = this.getDefaultFilters({ shouldNotClearDealershipListingValue: true });
            this.initRangeSelects();
            this.$emit('clearFilter', isTriggered);
        },
        handleShowListingWithSearchKeyword(key, value) {
            this.clearFilters();
            this.setFilter(key, value);
            this.showListing();
        }
    },
    watch: {
        filters: {
            handler: function (val) {
                this.$emit('updateFilter', val);
            },
            deep: true
        },
        shouldClearFilters() {
           if (this.shouldClearFilters) {
               this.filters = this.getDefaultFilters({ shouldNotClearBodyIdValue: true, shouldNotClearDealershipListingValue: true });
               this.initRangeSelects();
               this.$emit('clearFilter', true);
           }
        },
    }
}
</script>

<style scoped>
option:disabled {
    color: #c3c0c0;
}

.search-option {
    cursor: pointer;
}
</style>
